/*
 * BOGOS adds the free gift to the cart ~2s after a product is added. If the customer clicks
 * "Uitchecken" before that, the checkout opens without the gift. This holds the checkout
 * submit until the BOGOS gift line is in the cart (or MAX_WAIT has passed, e.g. offer paused).
 */
(function () {
  'use strict';

  var MAX_WAIT = 4000;
  var INTERVAL = 400;
  var GIFT_HANDLE = /sca_clone_freegift$/;

  function hasGift(cart) {
    return cart.items.some(function (item) {
      return GIFT_HANDLE.test(item.handle);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function waitForGift() {
    var start = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        fetchCart()
          .then(function (cart) {
            if (!cart.items.length || hasGift(cart) || Date.now() - start >= MAX_WAIT) return resolve();
            setTimeout(check, INTERVAL);
          })
          .catch(resolve);
      })();
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      submitter.setAttribute('aria-busy', 'true');
      submitter.style.opacity = '0.6';

      // Go to /checkout directly instead of re-submitting the form: the cart drawer re-renders
      // when BOGOS adds the gift, and Chrome cancels the submit of a form that gets detached.
      // Notes and quantities are already saved via ajax by the theme.
      waitForGift().then(function () {
        window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
      });
    },
    true
  );
})();
